<div class="installment-badges">
  <!-- Maximum Badge — hover ile açılır -->
  <div class="installment-badge-wrapper" (mouseenter)="openMaxPopup()" (mouseleave)="closeMaxPopup()">
    <button type="button" class="installment-badge-btn" #badgeBtn>
      <img src="assets/maximum@2x.png" alt="Maximum" class="installment-badge-logo">
      <span class="installment-badge-text">{{ badgeText }}</span>
    </button>

    <!-- Maximum Popup (sadece taksit varsa) -->
    <div class="installment-popup" *ngIf="showMaxPopup && maxInstallment > 0" [ngStyle]="maxPopupStyle">
      <div class="installment-popup-header installment-popup-header--max">
        <img src="assets/maximum@2x.png" alt="Maximum" class="installment-popup-logo">
        <span class="installment-popup-title">Maximum Taksit Seçenekleri</span>
      </div>
      <div class="installment-popup-body">
        <div class="installment-popup-row">
          <span class="installment-popup-label">Peşin (Tek Çekim)</span>
          <span class="installment-popup-amount installment-popup-amount--max" *ngIf="price > 0">
            {{ (price | number:'1.2-2':'tr') }} TL
          </span>
        </div>
        <div *ngFor="let opt of maxInstallments" class="installment-popup-row">
          <span class="installment-popup-label">{{ opt.label }}</span>
          <span class="installment-popup-amount installment-popup-amount--max" *ngIf="price > 0">
            {{ (price / opt.count | number:'1.2-2':'tr') }} TL x {{ opt.count }}
          </span>
        </div>
      </div>
      <div class="installment-popup-footer">
        Peşin fiyatına taksit · Seçim ödeme adımında yapılır.
      </div>
    </div>
  </div>

  <!-- Diğer Banka Seçenekleri — click ile popup açılır -->
  <button type="button" class="other-banks-btn" (click)="toggleBankTable($event)">
    <span class="other-banks-text">Diğer Banka Seçenekleri</span>
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
  </button>
</div>

<!-- Banka Taksit Tablosu Overlay -->
<div class="bank-table-overlay" *ngIf="showBankTable" (click)="closeBankTable()">
  <div class="bank-table-modal" (click)="$event.stopPropagation()">
    <div class="bank-table-header">
      <span class="bank-table-title">Taksit Seçenekleri</span>
      <button type="button" class="bank-table-close" (click)="closeBankTable()">&times;</button>
    </div>

    <!-- Tablo -->
    <div class="bank-table-scroll">
      <table class="bank-table">
        <thead>
          <tr>
            <th class="bank-table__bank-col">Banka</th>
            <th>Peşin</th>
            <th *ngIf="maxInstallment >= 3">3 Taksit</th>
            <th *ngIf="maxInstallment >= 6">6 Taksit</th>
            <th *ngIf="maxInstallment >= 9">9 Taksit</th>
          </tr>
        </thead>
        <tbody>
          <!-- Maximum — peşin fiyatına taksit -->
          <tr class="bank-table__row bank-table__row--max">
            <td class="bank-table__bank-col">
              <div class="bank-table__bank-info">
                <img src="assets/maximum@2x.png" alt="Maximum" class="bank-table__logo">
                <span class="bank-table__name">Maximum</span>
              </div>
            </td>
            <td>{{ (price | number:'1.0-0':'tr') }} TL</td>
            <td *ngIf="maxInstallment >= 3">{{ (price / 3 | number:'1.0-0':'tr') }} TL</td>
            <td *ngIf="maxInstallment >= 6">{{ (price / 6 | number:'1.0-0':'tr') }} TL</td>
            <td *ngIf="maxInstallment >= 9">{{ (price / 9 | number:'1.0-0':'tr') }} TL</td>
          </tr>
          <!-- Diğer bankalar — sadece peşin -->
          <tr *ngFor="let bank of banks" class="bank-table__row">
            <td class="bank-table__bank-col">
              <div class="bank-table__bank-info">
                <img [src]="bank.logo" [alt]="bank.name" class="bank-table__logo">
                <span class="bank-table__name">{{ bank.name }}</span>
              </div>
            </td>
            <td>{{ (price | number:'1.0-0':'tr') }} TL</td>
            <td *ngIf="maxInstallment >= 3" class="bank-table__disabled">—</td>
            <td *ngIf="maxInstallment >= 6" class="bank-table__disabled">—</td>
            <td *ngIf="maxInstallment >= 9" class="bank-table__disabled">—</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Yurtdışı otel uyarısı -->
    <div *ngIf="maxInstallment <= 0" class="bank-table-warning">
      Yurtdışı otellerinde taksit seçeneği bulunmamaktadır.
    </div>

    <div class="bank-table-footer">
      Taksit seçimi ödeme adımında yapılır.
    </div>
  </div>
</div>
